// Shared by Cloud Functions and the frontend (imported there as @shared).
// Team hometowns: US states and how a hometown reads.

export const STATES = {
  AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas",
  CA: "California", CO: "Colorado", CT: "Connecticut", DE: "Delaware",
  DC: "District of Columbia",
  FL: "Florida", GA: "Georgia", HI: "Hawaii", ID: "Idaho", IL: "Illinois",
  IN: "Indiana", IA: "Iowa", KS: "Kansas", KY: "Kentucky", LA: "Louisiana",
  ME: "Maine", MD: "Maryland", MA: "Massachusetts", MI: "Michigan",
  MN: "Minnesota", MS: "Mississippi", MO: "Missouri", MT: "Montana",
  NE: "Nebraska", NV: "Nevada", NH: "New Hampshire", NJ: "New Jersey",
  NM: "New Mexico", NY: "New York", NC: "North Carolina",
  ND: "North Dakota", OH: "Ohio", OK: "Oklahoma", OR: "Oregon",
  PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina",
  SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah",
  VT: "Vermont", VA: "Virginia", WA: "Washington", WV: "West Virginia",
  WI: "Wisconsin", WY: "Wyoming",
};

/**
 * Cleans a state from an upload or an admin edit: a two-letter code
 * becomes upper case; anything else (another country's region) is kept
 * as typed.
 * @param {*} value
 * @return {string|null}
 */
export function cleanState(value) {
  const s = String(value ?? "").trim().slice(0, 30);
  if (!s) return null;
  return /^[a-z]{2}$/i.test(s) ? s.toUpperCase() : s;
}

/**
 * "Glenbrook, Illinois", or "Glenbrook, IL" when short.
 * @param {object} team team document or summary row ({city, state})
 * @param {boolean} [short] state codes instead of names
 * @return {string} "" when the team has no hometown
 */
export function hometownText(team, short = false) {
  const state = team?.state ?
    (short ? team.state : STATES[team.state] ?? team.state) : "";
  return [team?.city, state].filter(Boolean).join(", ");
}
